/** @flow */
import Colors from './Colors';

const type = {
  base: 'Lato, sans-serif',
};

const style = {
  pageTitle: {
    fontSize: 24,
    fontWeight: 'normal',
    letterSpacing: 0.3,
    color: Colors.darkGray,
  },
  overviewRadioTitle: {
    fontSize: 30,
    color: Colors.primaryText,
  },
  cardTitle: {
    color: Colors.primaryText,
    fontSize: '2rem',
  },
  smallCardTitle: {
    color: Colors.primaryText,
    fontFamily: type.base,
    fontSize: 20,
  },
  huge: {
    color: Colors.primaryText,
    fontFamily: type.base,
    fontSize: 56,
  },
  large: {
    color: Colors.primaryText,
    fontFamily: type.base,
    fontSize: 45,
  },
  midLarge: {
    fontSize: 35,
    fontFamily: type.base,
    color: Colors.primaryText,
  },
  main: {
    color: Colors.primaryText,
    fontFamily: type.base,
    fontSize: 30,
  },
  secondary: {
    color: Colors.primaryText,
    fontFamily: type.base,
    fontSize: 24,
  },
  sub: {
    color: Colors.primaryText,
    fontFamily: type.base,
    fontSize: 18,
  },
  midSmall: {
    color: Colors.primaryText,
    fontFamily: type.base,
    fontSize: 15,
  },
  small: {
    color: Colors.primaryText,
    fontFamily: type.base,
    fontSize: 13,
  },
  xsmall: {
    color: Colors.primaryText,
    fontFamily: type.base,
    fontSize: 12,
  },
  xxsmall: {
    color: Colors.primaryText,
    fontFamily: type.base,
    fontSize: 10,
  },
  tableHeader: {
    color: Colors.secondaryText,
    fontSize: 13,
    opacity: 0.6,
  },
};

const weights = {
  light: 200,
  lighter: 300,
  normal: 400,
  bolder: 500,
  bold: 600,
};

export default {
  type,
  style,
  weights,
};



// WEBPACK FOOTER //
// ./src/common/themes/Fonts.js